export default "__VITE_ASSET__599984bc__"